<template>
    <div style="min-width:80%">
        <div class="titulo-grupo" :class="{'active':value}">
            <input type="checkbox" :class="checkboxType" :id="id" :checked="value" @change="cambio">
            <label :for="id">{{titulo}}</label>
            <svg xmlns="http://www.w3.org/2000/svg" width="17.908" height="12.147" viewBox="0 0 17.908 12.147">
                <path id="Trazado_24243" data-name="Trazado 24243" d="M8.954,0,0,9.359l2.667,2.788L8.954,5.576l6.287,6.571,2.667-2.788Z" transform="translate(17.908 12.147) rotate(180)" />
            </svg>
        </div>
        <div class="content " :class="{'collapsed':!value}">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        titulo:{
            default:'Titulo',
            type: String
        },
        value:{
            type:Boolean,
            default:false
        },
        checkboxType:{
            type:String,
            default:'normal'
        },
    },
    data(){
        return {
            id:null,
            VM_value:false
        }
    },
    mounted(){
        this.id = this._uid;
        this.VM_value = this.value
    },
    methods:{
        cambio(e){
            this.VM_value = e.target.checked
            this.$emit("change",e.target.checked)
        },
    },
    model:{
        prop:"value",
        event:"change"
    },
}
</script>

<style lang="scss" scoped>
.titulo-grupo{
    background-color: #F7F7F7;
    border-top: 1px solid black;
    border-bottom: 1px solid black;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px;

    input[type=checkbox].normal{
        background-color: var(--control-bg-color);
        font-size: inherit;
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        width: 26px;
        height: 26px;
        border-radius: 5px;
        border: 1px solid var(--control-color);
        cursor: pointer;
        margin-right: 0.5em;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 1.5em 1.5em;
        flex-grow: 0;

        //quitando algunas cossas que pone la base web
        margin-bottom: 0;
        margin-top: 0;
        margin-left: 0;

        &:checked {
            background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 512 512"><path d="m186 340l-90-91-32 31 122 122 262-261-32-31z"></path></svg>');
        }
        
    }

    input[type="checkbox"].switch{
        background-color: #CCCCCC;
        font-size: inherit;
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        width: 40px;
        height: 12px;
        border-radius: 5px;
        position: relative;
        cursor: pointer;
        margin-right: 0.5em;
        transform: translateY(50%);
        &:checked{
            background-color: #999999;
            &:after{
                background-color: black;
                left: 20px;
                //right: 0;
            }
        }

        &:after{
            position: absolute;
            content: '';
            height: 20px;
            width: 20px;
            border-radius: 50%;
            border: 1px solid black;
            background-color: white;
            left:0;
            right: auto;
            top: 0;
            transform: translateY(-25%);
            transition: left .5s ease-out 0s;
        }
        
    }

    label{
        flex-grow: 1;
        cursor: pointer;
        font-size: 14px;
        font-weight: bold;
    }
    svg{
        flex-grow: 0;
        transition: transform 1s;
    }

    &.active{
        svg{
            transform: rotate(180deg);
        }
    }
}

.content{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 16px;
    &.collapsed{
        display: none;
    }
}
</style>